import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { spacingNumerical, spacing } from '../constants/spacing.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var bottomSheetAttributesNative = {
  handle: {
    width: spacingNumerical.m,
    height: 4,
    color: 'border.inactive',
    borderRadius: 0
  },
  header: {
    color: 'text.primary'
  },
  backgroundColor: 'background.primary',
  content: {
    padding: {
      top: spacing.xxs,
      left: spacing.xxs,
      right: spacing.xxs,
      bottom: spacing.xxs
    }
  }
};
var bottomSheetThemeNative = _objectSpread({}, bottomSheetAttributesNative);

export { bottomSheetAttributesNative, bottomSheetThemeNative };
